<template>
  <div class="name-and-title">
    <div class="title">
      <h2>{{title}}</h2>
    </div>
    <div class="name">
      <table id="name">
        <colgroup>
          <col style="width:30mm;">
          <col style="width:60mm;">
        </colgroup>
        <tr>
          <th>氏名</th>
          <td>{{name}}</td>
        </tr>
      </table>

    </div>
  </div>

</template>


<script>
import RadarChart from '@/components/results/radar_chart.vue'
import AllChart from '@/components/results/all_chart.vue'
import ResultTable from '@/components/result_print/result_table.vue'
import SummaryTable from '@/components/result_print/summary_table.vue'
import InfoTable from '@/components/result_print/info_table.vue'
import { mean, standardDeviation, max } from 'simple-statistics'
import { roundAndToFixed, frequency } from "@/utils/statics.js"
import Plotly from 'plotly.js-dist';
import { makeDoc } from '@/components/pdf/jsPdf'
import html2canvas from 'html2canvas'
import logo from '!url-loader!@/assets/SSM.jpg'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  props: {
    title: {
      default: "",
      type: String,
    },
    name: {
      default: "",
      type: String,
    },
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}



</script>


<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  td {
    padding: 5pt;
  }
}
table#name {
  font-size: 16px;
}
.name {
  position: absolute;
  top: 5mm;
  right: 5mm;
}
.title {
  position: absolute;
  top: 5mm;
  left: 5mm;
}
.name-and-title {
  height: 10mm;
  margin-bottom: 3mm;
}
h2 {
  margin: 0mm 5mm;
}
</style>
